// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Zro7","inputDescription":"styles_inputDescription__2hdpQ"};